import React from "react";

const LogoWhiteSmall = ({ w, h }) => {
  return (
    <svg className={`w-${w} h-${h}`} viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 0C4.47716 0 0 4.47714 0 10V40C0 45.5229 4.47716 50 10 50H40C45.5228 50 50 45.5229 50 40V10C50 4.47714 45.5228 0 40 0H10ZM33.0229 23.3303C33.2839 23.2318 34.598 21.8315 34.598 19.6983C34.598 18.8794 33.5536 15.2466 28.5884 15.2466H12.0235L8 10L30.2581 10.0844C40.7708 10.0844 40.9095 19.2446 40.9095 19.6983C40.9095 22.6987 39.2436 24.6962 38.4717 25.6216L38.4016 25.7058C37.1824 24.4384 35.066 23.6134 33.0229 23.3303ZM12.1532 24.5567L30.5773 24.5943C34.009 24.5943 42 26.6324 42 40H36.0628C35.943 39.3456 35.8391 38.7246 35.7406 38.136C34.6002 31.3229 34.1886 28.8639 18.4112 29.4776V40H12.1532V24.5567Z"
        fill="white"
      />
    </svg>
  );
};

export default LogoWhiteSmall;
